import * as React from 'react'
import { IProviderProductObject } from '../../../types/index'
import { EntityProviderItemProduct } from '../../ui/entity/EntityProviders'

interface IServiceViewProductsProps {
  organizationId: string
  serviceProducts?: IProviderProductObject[]
  fetchProductsByOrganizationId: (organizationId: string) => void
}

class ServiceViewProducts extends React.Component<IServiceViewProductsProps> {
  constructor(props: IServiceViewProductsProps) {
    super(props)
  }

  public componentDidMount() {
    this.props.fetchProductsByOrganizationId(this.props.organizationId)
  }

  public render() {
    const { serviceProducts } = this.props
    return (
      <div>
        <div className='ml3 mt2'>
          {serviceProducts &&
            serviceProducts.map(product => (
              <EntityProviderItemProduct key={`product-${product.id}`}>{product.name}</EntityProviderItemProduct>
            ))}
        </div>
      </div>
    )
  }
}

export default ServiceViewProducts



// WEBPACK FOOTER //
// ./src/components/services/view/ServiceViewProducts.tsx